module.exports = __webpack_public_path__ + "img/index-solutions-vehicle-hover.268e1c92.png";